<template>
  <div class="my-devices">
    <!-- 数据展示区域 -->
    <div class="data-section">
      <div class="section-header">
        <div>
          <span style="font-size: 14px; color: #333">帮助管理</span>
        </div>
        <div class="toolbar">
          <el-button v-if="userRole === 0" type="primary" @click="openAddDialog">新增</el-button>

          <!-- 刷新按钮 -->
          <el-button type="text" @click="refreshData">
            <el-icon><Refresh /></el-icon>
          </el-button>

          <!-- 密度设置 -->
          <el-popover
            placement="bottom"
            width="160"
            v-model:visible="densityDialogVisible"
          >
            <div class="popover-content">
              <el-button
                class="density-button"
                :type="rowHeight === '80px' ? 'primary' : ''"
                @click="setRowHeight('80px')"
              >
                默认
              </el-button>
              <el-button
                class="density-button"
                :type="rowHeight === '60px' ? 'primary' : ''"
                @click="setRowHeight('60px')"
              >
                中等
              </el-button>
              <el-button
                class="density-button"
                :type="rowHeight === '30px' ? 'primary' : ''"
                @click="setRowHeight('30px')"
              >
                紧凑
              </el-button>
            </div>
            <template #reference>
              <el-button type="text" class="-button-spacustomcing">
                <el-icon><Grid /></el-icon>
              </el-button>
            </template>
          </el-popover>

          <!-- 列显示设置 -->
          <el-popover placement="bottom" width="100" v-model:visible="columnsDialogVisible">
          <div class="popover-content">
            <el-checkbox-group v-model="tempSelectedColumns">
              <el-checkbox
                v-for="column in columns"
                :key="column.prop"
                :label="column.prop"
              > 
                {{ column.label }}
              </el-checkbox>
            </el-checkbox-group>
            <div class="popover-footer">
              <el-button @click="resetColumns">重置</el-button>
              <el-button type="primary" @click="confirmColumns">确定</el-button>
            </div>
          </div>
          <template #reference>
            <el-button type="text">
              <el-icon><Setting /></el-icon>
            </el-button>
          </template>
        </el-popover>
        </div>
      </div>

      <!-- 表格区域 -->
      <el-table
        :data="tableData"
        style="width: 98.5%; margin-left: 10px; margin-right: 20px; margin-top: 10px;"
        :row-style="getRowStyle"
        :header-cell-style="{
        background: '#f5f7fa',
        color: '#909399',
        textAlign: 'center',
      }"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          v-for="column in visibleColumns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :align="column.align || 'center'"
        >
          <template #default="scope">
            <template v-if="column.prop === 'operation'">
              <div class="operation-buttons">
                <el-button type="text" style="color: red" @click="deleteHelpItem(scope.row.id)">
                  删除
                </el-button>
                <el-button type="text" style="color: blue" @click="editHelp(scope.row)">
                  编辑
                </el-button>
              </div>
            </template>
            <template v-else-if="column.prop === 'imageUrl'">
              <div class="image-preview-container" @click="showImageGallery(scope.row)">
                <el-image
                  v-if="scope.row[column.prop]"
                  style="width: 60px; height: 60px"
                  :src="scope.row[column.prop]"
                  fit="contain"
                  @click.stop="showSingleImage(scope.row[column.prop])"
                />
                <span v-else style="color: #999">无图片</span>
                <div v-if="scope.row.imageUrlList && scope.row.imageUrlList.length > 1" class="view-more-hint">
                  点击查看更多
                </div>
              </div>
            </template>
            <template v-else>
              {{ scope.row[column.prop] }}
            </template>
          </template>
        </el-table-column>

        <template #empty>
          <div class="empty-state">
            <el-icon class="empty-icon"><Box /></el-icon>
            <p class="empty-text">暂无数据</p>
          </div>
        </template>
      </el-table>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      width="500px"
      class="custom-dialog"
      @close="closeDialog"
    >
      <div class="dialog-content">
        <el-form :model="formData" label-width="100px" :rules="rules" ref="formRef">
          <el-form-item label="标题" prop="title">
            <el-input v-model="formData.title" placeholder="请输入标题" />
          </el-form-item>
          <el-form-item label="内容" prop="content">
            <el-input
              v-model="formData.content"
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
            />
          </el-form-item>
          <el-form-item label="图片" prop="imageBase64List">
            <div class="image-upload-section">
              <div class="upload-tip">最多可上传10张图片，大于800*800将会被压缩</div>
              <div class="image-list">
                <!-- 已上传的图片列表 -->
                <div v-for="(image, index) in formData.imageBase64List" :key="index" class="image-item">
                  <img :src="image" class="preview-image" @click="showSingleImage(image)" />
                  <div class="image-actions">
                    <el-button type="danger" size="small" @click="removeImageAt(index)" class="delete-button">
                      删除
                    </el-button>
                  </div>
                </div>
                
                <!-- 上传按钮，当图片数量小于10张时显示 -->
                <div v-if="formData.imageBase64List.length < 10" class="image-upload-container">
                  <el-upload
                    class="image-upload"
                    action="#"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="handleImageChange"
                  >
                    <div class="upload-placeholder">
                      <el-icon class="upload-icon"><Plus /></el-icon>
                      <div>点击上传</div>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 图片查看弹窗 -->
    <el-dialog
      title="图片查看"
      v-model="imageGalleryVisible"
      width="80%"
      class="image-gallery-dialog"
    >
      <div class="image-gallery">
        <div 
          v-for="(imageUrl, index) in currentImageList" 
          :key="index" 
          class="gallery-item"
          @click="showSingleImagePreview(imageUrl)"
        >
          <el-image
            :src="imageUrl"
            fit="cover"
            style="width: 200px; height: 200px; cursor: pointer;"
          />
        </div>
      </div>
    </el-dialog>

    <!-- 单张图片预览弹窗 -->
    <el-dialog
      v-model="singleImageVisible"
      title="图片预览"
      fullscreen
      class="single-image-dialog"
    >
      <div class="fullscreen-image-container">
        <el-image
          :src="currentSingleImage"
          fit="contain"
          class="fullscreen-image"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import { Box, Refresh, Grid, Setting, Plus } from "@element-plus/icons-vue";
import { getHelpList, createHelp, updateHelp, deleteHelp } from "@/api/help";
import { ImageCompressor } from "@/utils/imageCompressor";

export default {
  name: "HelpManagePage",
  components: {
    Box,
    Refresh,
    Grid,
    Setting,
    Plus,
  },
  setup() {
    const tableData = ref([]);
    const dialogVisible = ref(false);
    const dialogTitle = ref("新增帮助");
    const formRef = ref(null);
    const formData = ref({
      title: "",
      content: "",
      imageBase64List: [],
    });
    const userRole = ref(1); // 用户角色
    
    // 图片弹窗相关
    const imageGalleryVisible = ref(false);
    const singleImageVisible = ref(false);
    const currentImageList = ref([]);
    const currentSingleImage = ref('');

    // 初始化时获取用户角色
    onMounted(() => {
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        const user = JSON.parse(userInfo);
        userRole.value = user.role; // 0: 管理员, 1: 员工, 2: 维修工程师
      }
    });

    // 表格配置
    const columns = ref([
      { prop: "index", label: "序号", visible: true },
      { prop: "title", label: "标题", visible: true },
      { prop: "content", label: "内容", visible: true },
      { prop: "imageUrl", label: "图片", visible: true },
      { prop: "operation", label: "操作", visible: true },
    ]);

    // 根据用户角色初始化列显示
    onMounted(() => {
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        const user = JSON.parse(userInfo);
        userRole.value = user.role; // 0: 管理员, 1: 员工, 2: 维修工程师
        
        // 非管理员角色隐藏操作列
        if (userRole.value === 1 || userRole.value === 2) {
          // 从selectedColumns中移除operation
          const index = selectedColumns.value.indexOf('operation');
          if (index > -1) {
            selectedColumns.value.splice(index, 1);
          }
        }
      }
    });

    const selectedColumns = ref(columns.value.map((col) => col.prop));
    const visibleColumns = computed(() =>
      columns.value.filter((col) => selectedColumns.value.includes(col.prop))
    );
    
    const tempSelectedColumns = ref([]);
    const rowHeight = ref("80px");
    const densityDialogVisible = ref(false);
    const columnsDialogVisible = ref(false);

    const rules = {
      title: [
        { required: true, message: "请输入标题", trigger: "blur" },
        { min: 2, max: 50, message: "长度在 2 到 50 个字符", trigger: "blur" },
      ],
      content: [
        { required: true, message: "请输入内容", trigger: "blur" },
        { min: 5, max: 500, message: "长度在 5 到 500 个字符", trigger: "blur" },
      ],
    };

    // 加载数据
    const loadData = async () => {
      try {
        const response = await getHelpList();
        if (response.success) {
          tableData.value = response.data.map((item, index) => {
            // 处理图片数据，从imageBase64List数组中获取第一张图片作为预览
            const imageUrl = item.imageUrls && item.imageUrls.length > 0 ? 
              item.imageUrls[0] : 
              (item.imageUrl || ''); // 兼容旧版数据结构
              
            return {
              ...item,
              index: index + 1,
              imageUrl: imageUrl,
              // 保存完整的图片列表，用于详情查看
              imageUrlList: item.imageUrls || []
            };
          });
        } else {
          ElMessage.error(response.message || '获取数据失败');
        }
      } catch (error) {
        ElMessage.error('获取数据失败');
      }
    };

    // 提交表单
    const submitForm = async () => {
      if (!formRef.value) return;

      try {
        await formRef.value.validate();
        const apiCall = formData.value.id ? 
          updateHelp(formData.value.id, formData.value) : 
          createHelp(formData.value);

        const response = await apiCall;
        if (response.success) {
          ElMessage.success(response.message || '保存成功');
          dialogVisible.value = false;
          loadData(); // 重新加载数据
        } else {
          ElMessage.error(response.message || '保存失败');
        }
      } catch (error) {
        ElMessage.error('保存失败');
      }
    };

    // 删除帮助
    const deleteHelpItem = async (id) => {
      try {
        await ElMessageBox.confirm('确认删除该帮助？', '提示', {
          type: 'warning',
        });
        const response = await deleteHelp(id);
        if (response.success) {
          ElMessage.success(response.message || '删除成功');
          loadData(); // 重新加载数据
        } else {
          ElMessage.error(response.message || '删除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('删除失败');
        }
      }
    };


const getRowStyle = () => {
  return {
    height: rowHeight.value
  };
};

const tableRowClassName = ({ rowIndex }) => {
  return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
};

const openAddDialog = () => {
  dialogTitle.value = '新增帮助';
  formData.value = {
    title: '',
    content: '',
    imageBase64List: []
  };
  dialogVisible.value = true;
};

const editHelp = (row) => {
  dialogTitle.value = '编辑帮助';
  
  // 处理图片数据，优先使用imageUrlList
  let imageBase64List = [];
  if (row.imageUrlList && row.imageUrlList.length > 0) {
    // 如果有imageUrlList，直接使用
    imageBase64List = [...row.imageUrlList];
  } else if (row.imageUrl) {
    // 如果只有单张图片，将其添加到数组
    imageBase64List = [row.imageUrl];
  } else if (row.imageBase64) {
    // 兼容旧数据
    imageBase64List = [row.imageBase64];
  }
  
  formData.value = { 
    ...row,
    imageBase64List: imageBase64List
  };
  dialogVisible.value = true;
};

// 处理图片上传
const handleImageChange = async (file) => {
  const isImage = file.raw.type.startsWith("image/");
  if (!isImage) {
    ElMessage.error("请上传图片文件！");
    return;
  }
  
  // 检查图片数量限制
  if (formData.value.imageBase64List.length >= 10) {
    ElMessage.warning("最多只能上传10张图片");
    return;
  }

  const loading = ElLoading.service({
    lock: true,
    text: '图片处理中...',
    background: 'rgba(0, 0, 0, 0.7)'
  });

  try {
    // 将File对象转换为base64
    const reader = new FileReader();
    const base64 = await new Promise((resolve, reject) => {
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file.raw);
    });

    // 压缩图片
    const compressedBase64 = await ImageCompressor.compress(base64, {
      maxWidth: 800,
      maxHeight: 800,
      quality: 0.8
    });

    // 将新图片添加到数组中
    formData.value.imageBase64List.push(compressedBase64);
    ElMessage.success("图片上传成功");
  } catch (error) {
    ElMessage.error("图片处理失败，请重试");
    console.error("图片处理错误:", error);
  } finally {
    loading.close();
  }
};

// 删除特定索引的图片
// eslint-disable-next-line no-unused-vars
const removeImageAt = (index) => {
  if (index >= 0 && index < formData.value.imageBase64List.length) {
    formData.value.imageBase64List.splice(index, 1);
    ElMessage.success("图片已删除");
  }
};

// 删除所有图片
const removeImage = () => {
  formData.value.imageBase64List = [];
  ElMessage.success("所有图片已删除");
};


    // 关闭弹窗
    const closeDialog = () => {
      formRef.value?.resetFields();
      dialogVisible.value = false;
    };

    // 刷新数据
    const refreshData = () => {
      loadData();
      ElMessage.success("数据已刷新");
    };

    // 设置表格行高
    const setRowHeight = (height) => {
      rowHeight.value = height;
      densityDialogVisible.value = false;
    };

    // 重置列显示
    const resetColumns = () => {
      // 根据用户角色决定是否显示操作列
      if (userRole.value === 1 || userRole.value === 2) {
        // 非管理员角色不显示操作列
        tempSelectedColumns.value = columns.value
          .filter(col => col.prop !== 'operation')
          .map(col => col.prop);
      } else {
        // 管理员显示所有列
        tempSelectedColumns.value = columns.value.map(col => col.prop);
      }
      columnsDialogVisible.value = false;
    };

    // 确认列显示设置
    const confirmColumns = () => {
      if (tempSelectedColumns.value.length === 0) {
        ElMessage.warning("至少选择一列");
        return;
      }
      
      // 非管理员角色强制移除操作列
      if (userRole.value === 1 || userRole.value === 2) {
        const index = tempSelectedColumns.value.indexOf('operation');
        if (index > -1) {
          tempSelectedColumns.value.splice(index, 1);
        }
      }
      
      selectedColumns.value = [...tempSelectedColumns.value];
      columnsDialogVisible.value = false;
    };

    onMounted(() => {
      loadData();
      tempSelectedColumns.value = [...selectedColumns.value];
    });

    // 显示图片画廊
    const showImageGallery = (row) => {
      if (row.imageUrlList && row.imageUrlList.length > 1) {
        currentImageList.value = row.imageUrlList;
        imageGalleryVisible.value = true;
      } else if (row.imageUrl) {
        showSingleImage(row.imageUrl);
      }
    };

    // 显示单张图片
    const showSingleImage = (imageUrl) => {
      currentSingleImage.value = imageUrl;
      singleImageVisible.value = true;
    };

    // 从画廊中预览单张图片
    const showSingleImagePreview = (imageUrl) => {
      imageGalleryVisible.value = false;
      showSingleImage(imageUrl);
    };

    return {
      tableData,
      dialogVisible,
      dialogTitle,
      formRef,
      formData,
      rules,
      columns,
      visibleColumns,
      selectedColumns,
      tempSelectedColumns,
      rowHeight,
      densityDialogVisible,
      columnsDialogVisible,
      userRole,
      imageGalleryVisible,
      singleImageVisible,
      currentImageList,
      currentSingleImage,
      getRowStyle,
      tableRowClassName,
      openAddDialog,
      editHelp,
      deleteHelpItem,
      submitForm,
      closeDialog,
      refreshData,
      setRowHeight,
      resetColumns,
      confirmColumns,
      handleImageChange,
      removeImage,
      removeImageAt,
      showImageGallery,
      showSingleImage,
      showSingleImagePreview,
    };
  },
};
</script>

<style scoped>
.my-devices {
  padding: 20px;
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.data-section {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.toolbar {
  display: flex;
  align-items: center;
}

.toolbar .el-button {
  margin-left: 10px;
}

.empty-state {
  text-align: center;
  padding: 40px 0;
}

.empty-icon {
  font-size: 48px;
  color: #c0c4cc;
}

.empty-text {
  margin-top: 10px;
  color: #909399;
}

.even-row {
  background-color: #f5f7fa;
}

.odd-row {
  background-color: #ffffff;
}

.popover-content {
  padding: 10px;
}

.popover-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.density-button {
  margin: 5px 0;
  width: 100%;
}

.custom-dialog .dialog-content {
  max-height: 60vh;
  overflow-y: auto;
}

.image-upload-container {
  display: flex;
  align-items: center;
}

.image-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.upload-icon {
  font-size: 28px;
  color: #8c939d;
}

.preview-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.upload-right {
  margin-left: 20px;
}

.upload-text {
  margin-bottom: 10px;
  color: #606266;
}

.delete-button {
  margin-top: 10px;
}

.operation-buttons {
  display: flex;
  justify-content: center;
}

.operation-buttons .el-button {
  padding: 4px 8px;
  margin: 0 5px;
}

/* 多图片上传和预览样式 */
.image-upload-section {
  width: 100%;
}

.upload-tip {
  margin-bottom: 10px;
  color: #606266;
  font-size: 14px;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.image-item {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
  background-color: #f5f7fa;
}

.image-actions {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  padding: 2px 0;
}

.upload-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #909399;
  font-size: 12px;
}

/* 图片预览容器和徽章 */
.image-preview-container {
  position: relative;
  display: inline-block;
}

.view-more-hint {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  text-align: center;
  padding: 2px 0;
  font-size: 12px;
  cursor: pointer;
}

/* 图片弹窗样式 */
.image-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
  padding: 20px;
}

.gallery-item {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.gallery-item:hover {
  transform: scale(1.05);
}

.single-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

/* 全屏图片预览样式 */
.fullscreen-image-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  background-color: #00000000;
}

.fullscreen-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.image-gallery-dialog .el-dialog__body {
  padding: 0;
}

.single-image-dialog .el-dialog__body {
  padding: 0;
  height: 100vh;
  overflow: auto;
}

.single-image-dialog .el-dialog__header {
  background-color: rgba(0, 0, 0, 0);
  color: #00000000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.single-image-dialog .el-dialog__headerbtn {
  color: white;
}

.single-image-dialog .el-dialog__headerbtn:hover {
  color: #409eff;
}
</style>
